import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const BigCarSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="big-car-submissions"
    title="טבלת התחייבות עובד בגין קבלת רכב צמוד גדול"
    emptyLabel="אין הגשות להצגה"
    formPageUrl="https://rafael-car-show.co.il/big-car-form"
  />
);

export default BigCarSubmissionsTable;
